import { nodes } from 'state/product/config/DOM'

// ! const CDN_ROOT = 'https://static.marketreach.io/EBY'
// const CDN_ROOT = `${process.env.STATIC_ASSET_URL_BASE}`


export const config = {
  selectors: {
    id: {
      container: 'productContainer',
      count: 'h1-element',
      sort: {
        container: 'sort-container',
        active: 'sort-selected'
      }
      // ['product-sort-wrapper', 'product-sorting'], // 'product-sorting'


    }
  },
  thresholds: {
    display: {
      // Display by SKU if <= 5 Product IDs
      // bySKU: 5,
      byID: 5
    }
  },
  pixel: `${process.env.IMAGE_ROOT_URL_PATH}/px.png`,
  nodes: {
    colors: nodes.color,
    instance: nodes.instance
  },
  parentSelector: 'productContainer',
  properties: {
    fromJSON: [ 'activeSKU', 'id', 'price', 'salePrice', 'rating', 'reviewCount' ]
  },
  // series: {
  //   map: {
  //     f: 'First Ascent',
  //     s: 'Sport Shop',
  //     m: 'Motion',
  //     t: 'Travex',
  //     n: 'New',
  //     c: 'Clearance'
  //   },
  //   images: {
  //     f: `${CDN_ROOT}/images/series/first-ascent.png`,
  //     s: `${CDN_ROOT}/images/series/sport-shop.png`,
  //     m: `${CDN_ROOT}/images/series/motion.png`,
  //     t: `${CDN_ROOT}/images/series/travex.png`
  //   }
  // },
  currency: '$',
  urlBase: {
    cdn: `${process.env.IMAGE_ROOT_URL_PATH}`,
    product: '/p/', // '//www.eddiebauer.com/product/',
    // image: 'https://s7.marketreach.io/', // '//eddiebauer.scene7.com/is/image/EddieBauer/',
    mk: '/view/'
  }
}
